import { createDarkTheme, createLightTheme, type Theme } from '@fluentui/react-components';
import { brands, type Brand } from './tokens';

export type Mode = 'light' | 'dark';
/** What a caller may ask for. `system` follows `prefers-color-scheme`. */
export type ModePreference = Mode | 'system';

const build = (brand: Brand): Record<Mode, Theme> => {
  const { ramp } = brands[brand];
  const dark = createDarkTheme(ramp);
  // Fluent's dark recipe leaves the compound-brand ramp at light values, which makes
  // hovered accent surfaces wash out. Pin them to the ramp's mid shades.
  dark.colorBrandForeground1 = ramp[110];
  dark.colorBrandForeground2 = ramp[120];
  return { light: createLightTheme(ramp), dark };
};

export const taltThemes = build('talt');
export const royalAuraThemes = build('royalaura');

export const themes: Record<Brand, Record<Mode, Theme>> = {
  talt: taltThemes,
  royalaura: royalAuraThemes,
};

export const getTheme = (brand: Brand, mode: Mode): Theme => themes[brand][mode];

/**
 * The accent, for chrome the Fluent theme does not reach: rules, borders, wordmarks.
 * Shade 80 is legible on a light surface, 110 on a dark one.
 */
export const brandAccent = (brand: Brand, mode: Mode): string =>
  brands[brand].ramp[mode === 'light' ? 80 : 110];
